// extracted by mini-css-extract-plugin
export default {"notAuthorised":"NotAuthorised_notAuthorised__0RjTU","notAuthorisedTop":"NotAuthorised_notAuthorisedTop__a6GSD"};